import useScrollAnimation from "../hooks/useScrollAnimation";

const BNB_LOGO = "https://tokens.pancakeswap.finance/images/symbol/bnb.png";
const KLV_LOGO = "https://kleverscan.org/assets/klv-logo.png";

const ContractAddress = () => {
  const ref = useScrollAnimation();

  return (
    <div className="py-[40px] md:py-[80px] w-full bg-[#272529]">
      <div className="container mx-auto px-[6%]">
        <div ref={ref} className="animate-on-scroll scale-in">
          <h3 className="text-[26px] md:text-[47px] text-center font-bold font-Poppins text-white mb-8 md:mb-12">
            <span className="gradient-text">Dual-Chain Deployment</span>
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-[900px] mx-auto">
            {/* BSC Card */}
            <div className="content-box p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={BNB_LOGO}
                  alt="Binance Smart Chain"
                  className="w-10 h-10 rounded-full shadow-lg"
                />
                <h4 className="font-Poppins font-bold text-xl text-white">
                  Binance Smart Chain
                </h4>
              </div>
              <div className="space-y-3">
                <div>
                  <p className="text-xs font-Poppins uppercase tracking-wider text-[#E71CA5] font-bold">
                    Total Supply
                  </p>
                  <p className="font-Poppins text-lg md:text-xl font-bold text-white">
                    1 Quadrillion
                  </p>
                </div>
                <div>
                  <p className="text-xs font-Poppins uppercase tracking-wider text-[#E71CA5] font-bold">
                    Circulating Supply
                  </p>
                  <p className="font-Poppins text-lg md:text-xl font-bold text-white">
                    600 Trillion
                  </p>
                </div>
                <div>
                  <p className="text-xs font-Poppins uppercase tracking-wider text-[#E71CA5] font-bold">
                    Contract Address
                  </p>
                  <p className="font-Poppins text-sm md:text-base font-semibold text-white/80 break-all leading-relaxed">
                    0x18c8845Af8Bc9669b2F3af2462567cE35263C34a
                  </p>
                </div>
              </div>
            </div>

            {/* Klever Card */}
            <div className="content-box p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={KLV_LOGO}
                  alt="KleverChain"
                  className="w-10 h-10 rounded-full shadow-lg"
                />
                <h4 className="font-Poppins font-bold text-xl text-white">
                  KleverChain
                </h4>
              </div>
              <div className="space-y-3">
                <div>
                  <p className="text-xs font-Poppins uppercase tracking-wider text-[#15D9E8] font-bold">
                    Total Supply
                  </p>
                  <p className="font-Poppins text-lg md:text-xl font-bold text-white">
                    100 Billion
                  </p>
                </div>
                <div>
                  <p className="text-xs font-Poppins uppercase tracking-wider text-[#15D9E8] font-bold">
                    Circulating Supply
                  </p>
                  <p className="font-Poppins text-lg md:text-xl font-bold text-white">
                    80 Billion
                  </p>
                </div>
                <div>
                  <p className="text-xs font-Poppins uppercase tracking-wider text-[#15D9E8] font-bold">
                    Asset ID
                  </p>
                  <p className="font-Poppins text-sm md:text-base font-semibold text-white/80 break-all leading-relaxed">
                    <a
                      href="https://kleverscan.org/asset/SHIT-3UF0"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-[#15D9E8] transition-colors"
                    >
                      SHIT-3UF0
                    </a>
                  </p>
                </div>
                <div>
                  <p className="text-xs font-Poppins uppercase tracking-wider text-[#15D9E8] font-bold">
                    DEX Pair Address
                  </p>
                  <p className="font-Poppins text-xs md:text-sm font-semibold text-white/80 break-all leading-relaxed">
                    <a
                      href="https://bitcoin.me/pools/klv1qqqqqqqqqqqqqpgqgee3ylj7gmymn3n53xg86nru5rvfhp3cx04svu7flq"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-[#15D9E8] transition-colors"
                    >
                      klv1qqqqqqqqqqqqqpgqgee3ylj7gmymn3n53xg86nru5rvfhp3cx04svu7flq
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractAddress;
